import isApiError from '@anm/api/helpers/isApiError';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { appSumoActions, appSumoSelectors } from '../../../../store/modules/appSumo';

const useAppSumoUpgradeHandler = () => {
  const dispatch = useDispatch();
  const upgrade = useCallback(() => dispatch(appSumoActions.upgrade()), []);

  const isPending = useSelector(appSumoSelectors.selectUpgradePending);
  const { error: stateError, isError } = useSelector(appSumoSelectors.selectUpgradeError);
  const errorMessage = isApiError(stateError) ? stateError.message : stateError || undefined;

  return [{ error: errorMessage, isError, isPending }, { upgrade }] as const;
};

export default useAppSumoUpgradeHandler;
